export const Endpoint = () => `/api/v3/scan/removebyagentid/`;
export const Csrf = () => `/api/v3/scan/token/`;
export declare const QueryKey: never;
export type Payload = { agentid: string };
export type Response = void;
